import React, {memo} from "react";
import Joyride, {CallBackProps, STATUS, Step} from "react-joyride";
import {useDispatch, useSelector} from "react-redux";
import {TooltipContent, TourTooltip} from "./TourTooltip";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH, useMediaQuery} from "modules";
import {media} from "assets/css/media";
import {showTour} from "apps/DRAW_PREDICTOR/modules/selectors";
import {handleModalState} from "apps/DRAW_PREDICTOR/modules/actions/modals";

interface IProps {
	tourRef: React.RefObject<HTMLDivElement>;
}

export const Tour: React.FC<IProps> = memo(({tourRef}) => {
	const dispatch = useDispatch();
	const {t} = useTranslation(LANGUAGE_PATH);
	const show = useSelector(showTour);
	const isMobile = useMediaQuery(`(max-width: ${media.mobile})`);
	const stepPlacement = isMobile ? "center" : "top";

	const steps: Step[] = [
		{
			target: ".draw-first-step",
			content: (
				<TooltipContent
					title={t("draw.tutorial.step_one_header")}
					message={t("draw.tutorial.step_one_copy")}
				/>
			),
			placement: stepPlacement,
			disableBeacon: true,
			// floaterProps: {
			// 	disableAnimation: true,
			// },
		},
		{
			target: ".draw-second-step",
			content: (
				<TooltipContent
					title={t("draw.tutorial.step_two_header")}
					message={t("draw.tutorial.step_two_copy")}
				/>
			),
			placement: isMobile ? "center" : "left",
		},
		{
			target: ".draw-third-step",
			content: (
				<TooltipContent
					title={t("draw.tutorial.step_three_header")}
					message={t("draw.tutorial.step_three_copy")}
				/>
			),
			placement: stepPlacement,
		},
		{
			target: ".draw-third-step",
			content: (
				<TooltipContent
					title={t("draw.tutorial.step_four_header")}
					message={t("draw.tutorial.step_four_copy")}
				/>
			),
			placement: stepPlacement,
		},
		{
			target: ".draw-fifth-step",
			content: (
				<TooltipContent
					title={t("draw.tutorial.step_five_header")}
					message={t("draw.tutorial.step_five_copy")}
				/>
			),
			placement: "center",
		},
	];

	const handleJoyrideCallback = (data: CallBackProps) => {
		const {status} = data;

		if (status === STATUS.FINISHED) {
			tourRef.current?.scrollIntoView();
		}

		if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
			dispatch(handleModalState({tour: false}));
		}
	};

	return (
		<Joyride
			callback={handleJoyrideCallback}
			scrollOffset={600}
			steps={steps}
			run={show}
			tooltipComponent={TourTooltip}
			continuous={true}
			disableOverlay={true}
			styles={{
				options: {
					arrowColor: "#873EB4",
				},
			}}
		/>
	);
});

Tour.displayName = "Tour";
